import { render } from "./Register.vue?vue&type=template&id=165e4a98&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=165e4a98&scoped=true&lang=css"

import exportComponent from "C:\\Users\\IanFlew\\Documents\\Projects\\Fleetcare Configurator\\fleetcare-configurator-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165e4a98"]])

export default __exports__